export const RateSetsActionTypes = {
    API_RESPONSE_SUCCESS: '@@rate-sets/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@rate-sets/API_RESPONSE_ERROR',
    GET_ALL_RATE_SETS_FOR_USER: '@@rate-sets/GET_ALL_RATE_SETS_FOR_USER',
    GET_RATES_FOR_RATE_SET: '@@rate-sets/GET_RATES_FOR_RATE_SET',
    RESET_ALL_ERRORS: '@@rate-sets/RESET_ALL_ERRORS',
};
